import Field from '../_Field.js';
import Manager from '../../Manager'
export default class GoogleRecaptchaField extends Field
{
    static findAllFieldsInForm(form) {
        const inputsEls = form.querySelectorAll('input[data-sitekey]');
        const inputs = {};
        for (let el of inputsEls) {
            inputs[ el.name ] = el;
        }
        return inputs;
    }

    async getValue() {
        return await this.getToken();
    }

    getToken() {
        return new Promise((resolve, reject) => {
            if(grecaptcha === undefined) {
                reject('Google Recaptcha is not loaded');
            }
            grecaptcha.ready(() => {
                Manager.log('Google Recaptcha is ready');
                Manager.log('Using site key:', this.el.dataset.sitekey);
                grecaptcha.execute(this.el.dataset.sitekey, { action: 'submit' })
                  .then(token => {
                      resolve(token);
                  })
                  .catch(err => {
                      reject(err);
                  });
            });
        });
    }

}
